
export default {
  name: 'AssessFoot',
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    number: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    loggedIn() {
      return this.$store.state.loginStatus.loggedIn == 1
    },
  },
  methods: {
    click() {
      if (!this.loggedIn) {
        if (!this.isMobile) return this.$store.commit('setLoginStatus', { show: true })
        this.$href('/m/login/?quicklogin=1&emailorusername=&vvv=16728549930973728')
      }
    },
  },
}
